import { ref } from 'vue'

export default () => ({
  items: ref([]),
  inboxShowUnreadOnly: ref(false),
  inboxSidebarWidth: ref(360),
  inboxSidebarWidthMin: ref(180),
  inboxSidebarWidthMax: ref(520),
  selectedNotificationId: ref(null),
  checkedNotificationIds: ref(new Set())
})
